export const WEEK_PICKER_MODALITY_DATE_RANGE = "date_range";
export const WEEK_PICKER_MODALITY_WEEK_RANGE = "week_range";

export type WeekPickerIsoWeek = {
  year: number;
  week: number;
};
export type WeekPickerResult =
  | {
      type: typeof WEEK_PICKER_MODALITY_DATE_RANGE;
      start: Date;
      end: Date;
    }
  | {
      type: typeof WEEK_PICKER_MODALITY_WEEK_RANGE;
      start: WeekPickerIsoWeek;
      end: WeekPickerIsoWeek;
    }
  | null;
export type WeekPickerModality =
  | typeof WEEK_PICKER_MODALITY_DATE_RANGE
  | typeof WEEK_PICKER_MODALITY_WEEK_RANGE;
